import { isEmptyObject } from "../../utils/siteUtils";
import { Heading, SimpleLink } from "../../elements";
import React from "react";
import "./style.scss";

const ErrorView = props => {
  if (isEmptyObject(props)) {
    return null;
  } else {
    const { headingType, headingBody, body, link /*, ctaType, ctaName, iconName, colorScheme*/ } = props;
    // const ctaProps = ctaName && {
    //   buttonText: ctaName.value,
    //   ctaType: ctaType,
    //   iconName: iconName,
    //   colorScheme: colorScheme
    // };
    return (
      <section className="error-view grid">
        {headingType && headingBody && (
          <div className="title">
            <Heading type={headingType} html={headingBody} />
          </div>
        )}
        {body && (
          <div className="info">
            <p
              dangerouslySetInnerHTML={{
                __html: body.value
              }}
            />
          </div>
        )}
        <div className="cta">{link && <SimpleLink {...link.value} />}</div>
      </section>
    );
  }
};
export default ErrorView;
